import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.407 18.719A9.96 9.96 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 3.37 7.486A9.96 9.96 0 0 0 12 22a9.96 9.96 0 0 0 7.407-3.281m-.018-3.647A8 8 0 0 0 20 12c0-1.08-.214-2.112-.603-3.052l-2.774 1.144c.243.588.377 1.233.377 1.908 0 .68-.136 1.329-.382 1.92zm-4.337 4.325-1.144-2.774A5 5 0 0 1 12 17c-.68 0-1.33-.136-1.92-.382l-1.153 2.77A8 8 0 0 0 12 20c1.08 0 2.112-.214 3.052-.603M7 12c0 .675.134 1.32.377 1.908l-2.774 1.144A8 8 0 0 1 4 12c0-1.089.217-2.126.611-3.072l2.771 1.152A5 5 0 0 0 7 12m6.92-4.618 1.152-2.77A8 8 0 0 0 12 4c-1.08 0-2.112.214-3.052.603l1.144 2.774A5 5 0 0 1 12 7c.68 0 1.329.136 1.92.382M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
      clipRule: "evenodd"
    }
  )
);
var SvgSupport1Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Support1Outlined_default = SvgSupport1Outlined;

export { Support1Outlined_default as default };
